import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WorkgroupList } from 'src/app/models/workgroup-information.model';

@Component({
  selector: 'app-workgroupList',
  templateUrl: './workgrouplist.component.html'
})
export class WorkgroupListComponent implements OnInit {

  get NoWorkgroups(): boolean {
    return !this.workgroups || this.workgroups.length == 0
  }
  get HasWorkgroups(): boolean {
    return !this.NoWorkgroups
  }
  @Input('workgroups') workgroups!: any[];
  @Input('workgroupList') workgroupList!: WorkgroupList[];
  @Input('organisation') organisation!: any;
  @Input('filter') filter: string = <string>{};
  @Output('refreshWorkgroups') refreshWorkgroupsEmitter = new EventEmitter();
  hover: boolean = false;
  itemsPerPage: number = 10;
  pageSize!: number;
  currentPage: number = 1;
  columnName: string = 'name';
  orderBy: string = 'asc';
  descending: boolean = false;
  filterWorkgroups = { count: -1 };
  filteredWorkgroups: any[] = [];
  columns: string[] = ['name', 'members'];

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  onPageChanged(pageNum: any): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }

  changePagesize(num: number): void {
    this.itemsPerPage = num;
  }

  sortData(column: string) {
    if (this.columnName == column) {
      this.descending = !this.descending;
    } else {
      this.columnName = column;
      this.descending = false;
    }
    if (!this.descending) {
      this.orderBy = 'asc';
    } else {
      this.orderBy = 'desc';
    }
  }

  refreshWorkgroups() {
    this.refreshWorkgroupsEmitter.emit();
  }

}
